import { getCurrentUser } from 'helpers/api';
import Cookies from 'js-cookie';

const state = {
    CustomerName: null,
    CustomerNumber: null,
};

export async function setUserDetails() {
    if (!state.CustomerName || !state.CustomerNumber) {
        const { status, data } = await getCurrentUser();
        if (status !== 200) {
            return;
        }

        state.CustomerName = data.CustomerName;
        state.CustomerNumber = data.CustomerNumber;
    }

    Cookies.set('userSettings', {
        currentUser: state,
    });

    setUserName(state.CustomerName);
    setAcctNumber(state.CustomerNumber);
}

// ==================================================
// HANDLERS
// ==================================================

function setUserName(name) {
    const userFirstName = Array.from(document.getElementsByClassName('js--user-firstname'));
    const userFullName = Array.from(document.getElementsByClassName('js--user-fullname'));
    const userFirstAndLastName = name
        .toLowerCase()
        .split(' ')
        .map((k) => k.slice(0, 1).toUpperCase().concat(k.slice(1)));

    userFirstName.forEach((k) => (k.innerHTML = userFirstAndLastName[0])); // eslint-disable-line
    userFullName.forEach((k) => (k.innerHTML = userFirstAndLastName.join(' ')));
}

function setAcctNumber(acctNumber) {
    const acctNumbers = Array.from(document.getElementsByClassName('js--user-acctnumber'));

    acctNumbers.forEach((k) => (k.innerHTML = `Account #${acctNumber}`));
}

// ==================================================
// HELPERS
// ==================================================

// ==================================================
// INIT
// ==================================================

function init() {
    setUserDetails();
}

export default init;
